import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function useEditAppliedLeave(closeModal) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.EMPLOYEE_APPLIED_LEAVES,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries('get-all-Applied-leaves-for-admin');
        queryClient.invalidateQueries('get-employee-leaves-in-admin');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
